import type { EditControlProps } from '../../declare'
import { useRef } from 'react'
import { Upload, Button } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { postMsg } from 'src/components'
import { appStore } from 'src/stores'
import { getApiURL } from 'src/utils/axios'
import { uniqWith } from 'lodash'

const AttachUpload = (props: EditControlProps) => {
  const timer = useRef<any>(-1)

  const handleUpload = (fileList: File[]) => {
    const { Tenant = null, OrgId } = appStore.current.headers
    const { INPUT_DATA_API: url, FILE_SIZE: fileSize } = props.config

    const invalidFiles: File[] = []
    const file = new FormData()
    fileList.forEach(item => {
      if (fileSize && item.size / 1024 / 1024 > fileSize) {
        invalidFiles.push(item)
      } else {
        file.append('file', item)
      }
    })

    if (invalidFiles.length) {
      const errMsg = invalidFiles.slice(0, 3).map(item => item.name).join('，')
      postMsg(`${errMsg}等${invalidFiles.length}个上传文件超过${fileSize}MB，请重新选择`, 'error')
    }

    if (invalidFiles.length === fileList.length) return

    fetch(getApiURL(url), {
      method: 'POST',
      headers: { Tenant, OrgId },
      body: file
    }).then(res => res.json())
      .then(res => {
        if (res && res.IsSuccessful) {
          postMsg('上传成功')
          // 存在已上传的文件，所以这边做 concat 处理
          const uploadedFiles = uniqWith(res.Data.concat(props.value || []), function (a: any, b: any) { return a.FileName === b.FileName })
          props.onChange?.(uploadedFiles)
        } else {
          postMsg('上传失败', 'error')
        }
      })
  }

  const beforeUpload = (File: any, fileList: any[]) => {
    // 多选上传时，这个方法会重复调用，因此定时以节流
    clearTimeout(timer.current)
    timer.current = setTimeout(() => handleUpload(fileList), 300)
    return false
  }

  const handleRemove = (file: any) => {
    const findIndex = props.value.findIndex((item: any) => item.FileName === file.name)
    findIndex !== -1 && props.onChange?.(props.value.filter((item: any) => item.FileName !== file.name))
  }

  const { __READONLY__, EDITABLE, FILE_TYPES } = props.config
  const disabled = __READONLY__ || !EDITABLE || props.evtConfig?.disabled
  return (
    <Upload
      multiple
      disabled={disabled}
      accept={FILE_TYPES}
      fileList={(props.value || []).map((item: any, index: number) => ({
        uid: -(index + 1),
        name: item.FileName,
        status: 'done',
        url: item.FilePath
      }))}
      beforeUpload={beforeUpload}
      onRemove={handleRemove}
    >
      <Button icon={<UploadOutlined />} disabled={disabled}>选择文件</Button>
    </Upload>
  )
}

export default AttachUpload